var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "profiles" }, [
    _c("h3", [_vm._v("Profiles")]),
    _vm._v(" "),
    _vm.profiles.length
      ? _c(
          "ul",
          { staticClass: "profiles__ul" },
          _vm._l(_vm.profiles, function (profile, idx) {
            return _c("li", { key: idx, staticClass: "profiles__li" }, [
              _c("span", [
                _vm._v("\n        " + _vm._s(profile.fullname) + "\n      "),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm.revealForm && profile.fullname === _vm.fullname
                  ? _c(
                      "button",
                      {
                        staticClass: "profiles__edit-btn",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.resetFormFields()
                          },
                        },
                      },
                      [_vm._v("\n          Cancel\n        ")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "profiles__edit-btn",
                        on: {
                          click: function ($event) {
                            return _vm.updateProfile(profile.fullname)
                          },
                        },
                      },
                      [_vm._v("\n          View Details\n        ")]
                    ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "profiles__remove-btn",
                    on: {
                      click: function ($event) {
                        return _vm.$actions.deleteProfile(profile)
                      },
                    },
                  },
                  [_vm._v("\n          Remove\n        ")]
                ),
              ]),
            ])
          }),
          0
        )
      : _c("p", [_vm._v("\n    Create your first profile\n  ")]),
    _vm._v(" "),
    _c("button", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.revealForm,
          expression: "!revealForm",
        },
      ],
      staticClass: "btn",
      domProps: { textContent: _vm._s("Add new profile?") },
      on: {
        click: function ($event) {
          $event.preventDefault()
          _vm.revealForm = !_vm.revealForm
          _vm.formType = "create"
        },
      },
    }),
    _vm._v(" "),
    _c(
      "form",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.revealForm,
            expression: "revealForm",
          },
        ],
        staticClass: "profiles__form-title",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            _vm.formType === "update" ? _vm.saveProfile() : _vm.createProfile()
          },
        },
      },
      [
        _c("h5", {
          domProps: {
            textContent: _vm._s(
              _vm.formType == "update" ? "Update Profile" : "New Profile"
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "profile-label", attrs: { for: "fullname" } },
          [_vm._v("\n      Full Name*\n    ")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formProfile.fullname,
              expression: "formProfile.fullname",
            },
          ],
          staticClass: "profile-input",
          attrs: { type: "text", id: "fullname", required: "" },
          domProps: { value: _vm.formProfile.fullname },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.formProfile, "fullname", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "profile-label", attrs: { for: "dob" } }, [
          _vm._v("\n      Date of Birth (DD/MM/YYYY)*\n    "),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formProfile.dob,
              expression: "formProfile.dob",
            },
          ],
          staticClass: "profile-input",
          attrs: { type: "text", id: "dob", required: "" },
          domProps: { value: _vm.formProfile.dob },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.formProfile, "dob", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "profile-label", attrs: { for: "gender" } },
          [_vm._v("\n      Gender*\n    ")]
        ),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formProfile.gender,
                expression: "formProfile.gender",
              },
            ],
            staticClass: "profile-select",
            attrs: { id: "gender", required: "" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.formProfile,
                  "gender",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          [
            _c("option", { attrs: { value: "Male", selected: "" } }, [
              _vm._v("\n        Male\n      "),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "Female" } }, [
              _vm._v("\n        Female\n      "),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "Prefer not to say" } }, [
              _vm._v("\n        Prefer not to say\n      "),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.formProfile.gender != "Male"
          ? _c("div", [
              _c(
                "label",
                { staticClass: "profile-label", attrs: { for: "pregnant" } },
                [
                  _vm._v(
                    "\n        Is this patient pregnant or breastfeeding?\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formProfile.pregnant_or_breastfeeding,
                      expression: "formProfile.pregnant_or_breastfeeding",
                    },
                  ],
                  staticClass: "profile-select",
                  attrs: { id: "pregnant", required: "" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formProfile,
                        "pregnant_or_breastfeeding",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "No", selected: "" } }, [
                    _vm._v("\n          No\n        "),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "Yes" } }, [
                    _vm._v("\n          Yes\n        "),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "profile-label", attrs: { for: "address" } },
          [_vm._v("\n      Address*\n    ")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formProfile.address,
              expression: "formProfile.address",
            },
          ],
          staticClass: "profile-input",
          attrs: { type: "text", id: "address", required: "" },
          domProps: { value: _vm.formProfile.address },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.formProfile, "address", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "profile-label", attrs: { for: "phone" } }, [
          _vm._v("\n      Phone*\n    "),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formProfile.phone,
              expression: "formProfile.phone",
            },
          ],
          staticClass: "profile-input",
          attrs: { type: "text", id: "phone", required: "" },
          domProps: { value: _vm.formProfile.phone },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.formProfile, "phone", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "profile-label", attrs: { for: "patient_allergies" } },
          [_vm._v("\n      Patient Allergies (optional)\n    ")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formProfile.patient_allergies,
              expression: "formProfile.patient_allergies",
            },
          ],
          staticClass: "profile-input",
          attrs: { type: "text", id: "patient_allergies" },
          domProps: { value: _vm.formProfile.patient_allergies },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.formProfile,
                "patient_allergies",
                $event.target.value
              )
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "profile-label",
            attrs: { for: "patient_conditions" },
          },
          [_vm._v("\n      Patient Medical Conditions (optional)\n    ")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formProfile.patient_conditions,
              expression: "formProfile.patient_conditions",
            },
          ],
          staticClass: "profile-input",
          attrs: { type: "text", id: "patient_conditions" },
          domProps: { value: _vm.formProfile.patient_conditions },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.formProfile,
                "patient_conditions",
                $event.target.value
              )
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "profile-label",
            attrs: { for: "patient_medications" },
          },
          [_vm._v("\n      Patient Medications (optional)\n    ")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formProfile.patient_medications,
              expression: "formProfile.patient_medications",
            },
          ],
          staticClass: "profile-input",
          attrs: { type: "text", id: "patient_medications" },
          domProps: { value: _vm.formProfile.patient_medications },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.formProfile,
                "patient_medications",
                $event.target.value
              )
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "profiles__actions-btns" }, [
          _c("button", {
            staticClass: "btn",
            domProps: { textContent: _vm._s(_vm.loading ? "Saving" : "Save") },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--cancel",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.resetFormFields()
                },
              },
            },
            [_vm._v("\n        Cancel\n      ")]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }